import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Modal from 'react-bootstrap/Modal';
import { FaExpand } from 'react-icons/fa';
import { Docs } from '@splytech-io/router';
import { getUniqueElementId } from '../lib/helpers';
import { FreezeValue, WhenDefined } from './FX';
import { JSONInspect } from './JSONInspect';
import { SectionCard } from './SectionCard';
import { StatusCode } from './StatusCode';


export function ResponseExamples(props: {
  examples: Docs.ResponseExample[]
}) {
  const [showExampleNumber, setShowExampleNumber] = useState<number>();

  return (
    <>
      <SectionCard caption="Response Examples" content={() =>
        <ListGroup variant={'flush'}>
          {props.examples.map((item, index) =>
            <ListGroupItem key={getUniqueElementId(item)}
                           className="d-flex justify-content-between align-items-center clickable"
                           onClick={() => setShowExampleNumber(index)}
            >
              <StatusCode statusCode={item.statusCode} statusText={item.title}/>
              <FaExpand/>
            </ListGroupItem>,
          )}
        </ListGroup>
      }/>

      <Modal
        show={showExampleNumber !== undefined}
        size="lg"
        centered
        onHide={() => setShowExampleNumber(undefined)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Response Example
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FreezeValue value={showExampleNumber} fn={(showExampleNumber) =>
            <WhenDefined value={showExampleNumber} then={(showExampleNumber) =>
              <Tabs defaultActiveKey={showExampleNumber}>
                {props.examples.map((item, index) =>
                  <Tab eventKey={index} title={<StatusCode hideStatusText={true} statusCode={item.statusCode}/>}>
                    {item.description && <p className="mt-3">{item.description}</p>}
                    <JSONInspect json={item.json}/>
                  </Tab>,
                )}
              </Tabs>
            }/>
          }/>
        </Modal.Body>
      </Modal>
    </>
  );
}
